import comp from "./LearningGoalsStandardsTagModal";
export default comp;
